import { render, staticRenderFns } from "./staff-manage.vue?vue&type=template&id=a4a12be0&scoped=true&"
import script from "./staff-manage.vue?vue&type=script&lang=js&"
export * from "./staff-manage.vue?vue&type=script&lang=js&"
import style0 from "./staff-manage.vue?vue&type=style&index=0&id=a4a12be0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a12be0",
  null
  
)

export default component.exports